import { computed, type ComputedRef, type Ref } from 'vue'

import type { InputMaybe, Scalars } from '@/graphql/api'

import { useMoneyFormatter } from '@/plugins/money-formatter.ts'
import { useCurrency } from '@/plugins/currency.ts'

type Amount = Scalars['Decimal']['input'] | number | undefined | null
type PriceRange =
    | {
          max?: InputMaybe<{ amount: Amount }>
          min?: InputMaybe<{ amount: Amount }>
      }
    | null
    | undefined

export function useFormattedPriceRange(
    range: Readonly<Ref<PriceRange>> | ComputedRef<PriceRange>
): ComputedRef<string> {
    const currency = useCurrency()
    const formatMoney = useMoneyFormatter()

    const formatValue = (value: number) =>
        formatMoney({
            amount: value.toString(),
            currency: currency.value,
        })

    return computed(() => {
        if (!range.value?.min?.amount || !range.value.max?.amount) {
            return ''
        }

        const from = formatValue(Number(range.value.min.amount))
        const to = formatValue(Number(range.value.max.amount))

        return `${from} - ${to}`
    })
}
